import { Link, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Icon } from '@nazka/nazka.mapframe.components';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';

import routes from '@App/app.routes';

import './breadcrumbs.styl';

function Breadcrumbs() {
  const location = useLocation();
  const { companyId, vacancyId } = useParams();
  const flattenRoutes = rts => rts.flatMap(r => (r?.children ? flattenRoutes(r.children) : r));
  const flattenedRoutes = flattenRoutes(routes);

  const allVacancies = useSelector(state => state.map.allVacancies);

  return (
    <nav className="breadcrumbs">
      <ul className="breadcrumbs__list">
        <li className="breadcrumbs__list__item">
          <Link to="/" className="breadcrumbs__list__item__link">{routes[0].title}</Link>
          <Icon icon={faAngleRight} className="breadcrumbs__list__item__icon" />
        </li>
        {allVacancies && !!allVacancies.length && (
          <>
            <li className="breadcrumbs__list__item">
              <Link to="/vacatures" className="breadcrumbs__list__item__link">
                {flattenedRoutes.find(r => r.path === '/vacatures')?.title}
              </Link>
              <Icon icon={faAngleRight} className="breadcrumbs__list__item__icon" />
            </li>
            {location.pathname === '/vacatures/filter' && (
              <li className="breadcrumbs__list__item">
                <Link to="/vacatures/filter" className="breadcrumbs__list__item__link">
                  {flattenedRoutes.find(r => r.path === '/vacatures/filter')?.title}
                </Link>
                <Icon icon={faAngleRight} className="breadcrumbs__list__item__icon" />
              </li>
            )}
          </>
        )}
        {((companyId && !vacancyId) || (companyId && !allVacancies.length)) && (
          <li className="breadcrumbs__list__item">
            <Link to={`/${companyId}`} className="breadcrumbs__list__item__link">Bedrijf</Link>
            <Icon icon={faAngleRight} className="breadcrumbs__list__item__icon" />
          </li>
        )}
        {vacancyId && (
          <li className="breadcrumbs__list__item">
            <Link to={`/${companyId}/${vacancyId}`} className="breadcrumbs__list__item__link">Vacature</Link>
            <Icon icon={faAngleRight} className="breadcrumbs__list__item__icon" />
          </li>
        )}
        {location.pathname?.includes('mobiliteitsaanbod') && (
          <li className="breadcrumbs__list__item">
            <Link to={`/${companyId}/${vacancyId}/mobiliteitsaanbod`} className="breadcrumbs__list__item__link">Mobiliteitsaanbod</Link>
            <Icon icon={faAngleRight} className="breadcrumbs__list__item__icon" />
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Breadcrumbs;